import api from '@/api';
import { QuestBoxMovementRequest } from './BoxMovement.types';
import { API_BASE_URL } from '../../index';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportBoxMovement(
  params: QuestBoxMovementRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/BoxMovement`,
    params,
  )) as unknown;

  return result as BlobPart;
}
